<template>
  <transition name="fade-transition" >
    <div id="product-image-container" ref="product-image-container">
      <router-link tag="div" align="center" justify="center" :to="'/product/' + product.url_key" class="product">
        <transition name="fade-transition" appear >
          <div :style="'height:' + imageContainerHeight() + ';'">
            <div>
              <div id="frame" ref="frame" >

              </div>
              <v-img
              eager
              :src="product.base_image.optimized.medium"
              :lazy-src="product.base_image.optimized.small"
              width="100%"
              >
              </v-img>
              <div class="product-title">
                <br>
                <b>{{product.name}}</b>
              </div>
            </div>
          </div>
        </transition>
        <br>
        <div style="clear:both;;">

        </div>

      </router-link>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ProductList',
  props: {
    product: {
      type: Object,
      default: () => null
    },
    poster: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    ready: false,
  }),
  computed: {
    locale () {
      if (!this.$store.state.app.locale) {
        // Set default locale
        return {code: process.env.VUE_APP_I18N_LOCALE}
      }
      return this.$store.state.app.locale
    }
  },
  mounted() {
    let component = this;
    setTimeout(function(){
       component.ready = true;
    }, 100);
  },
  methods: {
    getAuthUserFullName(){
      return this.$store.getters.getAuthUserFullName;
    },
    imageContainerHeight() {
      // let width = this.$refs['product-image-container'].offsetWidth;
      // let height = width * 1.4142;
      return '250px';
      return this.imageContainerHeight = height.toString() + 'px';
    }
  }
};
</script>

<style lang="scss" scoped>

.product {
  cursor: pointer;
}

#product-image-container {
  min-height:230px;
}

.product-image:hover {
    // box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    -webkit-transform: scale(1.02, 1.02);
    transform: scale(1.02, 1.02);
    -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.product-title {
  font-family: 'Playfair Display', serif;
}

.product-subtitle {
  font-family: 'Roboto Mono', monospace;
}

.product:active {
  // box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
  -webkit-transform: scale(0.98, 0.98);
  transform: scale(0.98, 0.98);
  -webkit-transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.black-thin-frame {
  border: 3px solid black;
}



</style>
